import { KeyboardEvent } from "react";
import { NonEmptyArray } from "components/form/utils";

export const keyCodes = {
  Enter: "Enter",
  Space: " ",
} as const;

export function fromKeyCodeFilter<A, B>(
    code: typeof keyCodes[keyof typeof keyCodes],
    f: (event: KeyboardEvent<A>) => B
): (event: KeyboardEvent<A>) => B | void {
  return fromKeyCodesFilter([code], f);
}

export function fromKeyCodesFilter<A, B>(
    codes: NonEmptyArray<typeof keyCodes[keyof typeof keyCodes]>,
    f: (event: KeyboardEvent<A>) => B
): (event: KeyboardEvent<A>) => B | void {
  return event => {
    return codes.some(code => code === event.key) ? f(event) : undefined;
  };
}
